type MethodProps = {
  GET: "GET";
  POST: "POST";
  DELETE: "DELETE";
  PATCH: "PATCH";
  PUT: "PUT";
};

export const METHOD: MethodProps = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PATCH: "PATCH",
  PUT: "PUT",
};
